<script setup>
import { useGlobalStore } from "@stores/global";
import { useGlobeStore } from "@stores/globe";
import IconX from "@components/icons/X.vue";
import ToggleInput from "@components/ToggleInput.vue";

const globalStore = useGlobalStore();
const globeStore = useGlobeStore();

function close() {
    globalStore.setPage("explore");
}
</script>

<template>
    <Transition name="panel" appear>
        <div
            class="settings-panel bg-marine-800 border-marine-500 flex flex-col gap-10 p-6 lg:border-l"
        >
            <div class="flex items-center justify-between">
                <p class="h6 leading-[0.9] font-bold tracking-tight uppercase">
                    Settings
                </p>
                <button
                    class="border-marine-600 shadow-marine-600 flex size-8 items-center justify-center rounded-[4px] border-2 bg-yellow-400 shadow-[0_4px_0]"
                    @click="close"
                >
                    <IconX class="text-marine-600 size-3" />
                </button>
            </div>

            <div class="flex flex-1 flex-col gap-3">
                <!-- <ToggleInput
                    label="Show Locked"
                    :model-value="globeStore.showLocked"
                    @update:model-value="globeStore.toggleLocked()"
                /> -->
                <ToggleInput
                    label="Show Routes"
                    :model-value="globeStore.showLines"
                    @update:model-value="globeStore.toggleLines()"
                />
                <!-- <ToggleInput
                    label="Sound"
                    :model-value="globalStore.soundOn"
                    @update:model-value="globalStore.toggleSound()"
                /> -->
                <ToggleInput
                    label="Auto Rotate"
                    :model-value="globeStore.autoRotateEnabled"
                    @update:model-value="globeStore.toggleAutoRotate()"
                />
            </div>

            <div class="flex flex-col gap-4">
                <a
                    href="https://www.expedia.com/lp/b/terms-of-service"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="body-sm font-extrabold tracking-wide text-yellow-400 uppercase"
                >
                    Terms and conditions
                </a>
                <a
                    href="https://www.expedia.com/legal/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="body-sm font-extrabold tracking-wide text-yellow-400 uppercase"
                >
                    Privacy Policy
                </a>
            </div>
        </div>
    </Transition>
</template>

<style scoped>
.settings-panel {
    grid-column: -6 / -1;
    grid-row: 2 / -1;
    z-index: 3;
    overflow-y: auto;
}

@media (max-width: 1024px) {
    .settings-panel {
        grid-column: 1 / -1;
    }
}
</style>
